(() => {
  'use strict';
  const screen = window.matchMedia('(max-width: 760px)');
  const wrappers = [];
  const reordered = [];
  const initialDetails = new Map();
  const navs = [];
  let mounted = false;
  let counter = 0;
  const text = key => document.body.dataset[key] || '';
  const protectedArea = node => node.closest('.rd, .results, .results-stats, [data-hw-sci], [data-hw-ses], .finance-callout, .bz-calc, form, .shopify-policy__container');

  function disclosure(parent, heading, nodes, label) {
    if (!parent || !nodes.length || protectedArea(parent)) return;
    const detail = document.createElement('details');
    detail.className = 'mc-disclosure';
    const summary = document.createElement('summary');
    if (label) summary.textContent = label;
    const body = document.createElement('div');
    body.className = 'mc-disclosure__body';
    detail.append(summary, body);
    const moved = [];
    const move = (node, target) => {
      const marker = document.createTextNode('');
      node.before(marker);
      moved.push([node, marker]);
      target.append(node);
    };
    const first = heading && heading.parentElement === parent ? heading : nodes[0];
    first.before(detail);
    if (heading) move(heading, summary);
    nodes.forEach(node => move(node, body));
    wrappers.push({ detail, moved });
    return detail;
  }

  function card(selector, contentSelector = ':scope > p', headingSelector = ':scope > h3') {
    document.querySelectorAll(selector).forEach(parent => {
      const heading = parent.querySelector(headingSelector);
      const nodes = Array.from(parent.querySelectorAll(contentSelector));
      if (heading && nodes.length) disclosure(parent, heading, nodes);
    });
  }

  function sectionDetails(selector) {
    document.querySelectorAll(selector).forEach(parent => {
      const heading = parent.querySelector('h2');
      const nodes = Array.from(parent.children).filter(node => node !== heading && !node.matches('.stages__disclaimer,.smart__guidance'));
      if (!heading || !nodes.length) return;
      const detail = disclosure(parent, heading, nodes);
      if (detail) detail.classList.add('mc-section-disclosure');
    });
  }

  function readingSections(root) {
    if (!root || protectedArea(root)) return;
    const headings = Array.from(root.querySelectorAll(':scope > h2'));
    headings.forEach(heading => {
      // Keep warnings, purchasing rights and medical/safety guidance in plain sight.
      if (/safety|\bsafe\b|risk|medical|health professional|contraindicat|warning|before you|before.*start|skip|shorten|important|warranty|return|refund|terms|disclaimer|repayment|interest rate|finance|rebate|tax/i.test(heading.textContent)) return;
      const nodes = [];
      let next = heading.nextElementSibling;
      while (next && next.tagName !== 'H2') {
        if (next.matches('.article-next,nav,form,.rd,.results,.results-stats,.finance-callout,.bz-calc,[data-hw-sci],[data-hw-ses]') || next.querySelector('form,.rd,.results,.results-stats,.finance-callout,.bz-calc,[data-hw-sci],[data-hw-ses]')) return;
        nodes.push(next);
        next = next.nextElementSibling;
      }
      if (nodes.some(node => /not medical advice|qualified health|consult (a|your) (doctor|health)|contraindication|seek medical|safety warning/i.test(node.textContent))) return;
      if (nodes.length) disclosure(root, heading, nodes);
    });
  }

  function closeInitially(selector) {
    document.querySelectorAll(selector).forEach(detail => {
      if (protectedArea(detail)) return;
      initialDetails.set(detail, detail.open);
      detail.open = false;
    });
  }

  function readingNav(root) {
    if (!root || root.querySelector('.mc-page-nav')) return;
    const headings = Array.from(root.querySelectorAll(':scope > h2, :scope > h3')).filter(h => h.textContent.trim());
    if (headings.length < 3) return;
    const nav = document.createElement('nav');
    nav.className = 'mc-page-nav';
    nav.setAttribute('aria-label', text('mcContents'));
    const detail = document.createElement('details');
    const summary = document.createElement('summary');
    summary.textContent = text('mcContents');
    const list = document.createElement('ul');
    headings.forEach(h => {
      const oldId = h.getAttribute('id');
      if (!oldId) { do { counter += 1; h.id = 'mc-section-' + counter; } while (document.querySelectorAll('[id="' + h.id + '"]').length > 1); }
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#' + encodeURIComponent(h.id);
      link.textContent = h.textContent.trim();
      link.addEventListener('click', () => { detail.open = false; });
      item.append(link); list.append(item);
      navs.push({ heading: h, oldId });
    });
    detail.append(summary, list); nav.append(detail); root.prepend(nav);
    navs.push({ nav });
  }

  function revealHash() {
    if (!location.hash) return;
    let target;
    try { target = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch { return; }
    if (!target) return;
    let ancestor = target;
    while (ancestor) {
      if (ancestor.tagName === 'DETAILS') ancestor.open = true;
      ancestor = ancestor.parentElement;
    }
    if (target.matches('.smart, .stages')) {
      const detail = target.querySelector('.mc-section-disclosure');
      if (detail) detail.open = true;
    }
    if (target.id === 'FullSpecs') {
      const detail = target.querySelector('details');
      if (detail) detail.open = true;
    }
  }

  function activeControl() {
    const active = document.activeElement;
    return active && active !== document.body && active !== document.documentElement ? active : null;
  }

  function restoreFocus(target) {
    if (!target || !target.isConnected) return;
    let ancestor = target.parentElement;
    while (ancestor) {
      if (ancestor.tagName === 'DETAILS') ancestor.open = true;
      ancestor = ancestor.parentElement;
    }
    const temporary = !target.matches('a[href],button,input,select,textarea,summary,[tabindex]');
    if (temporary) {
      target.setAttribute('tabindex', '-1');
      target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
    }
    target.focus({ preventScroll: true });
  }

  function mount() {
    if (mounted || !screen.matches) return;
    const active = activeControl();
    mounted = true;
    document.documentElement.classList.add('mc-mobile-ready');
    closeInitially('.pdp__details > details, .specs__wrap, .faq-list > details, .considerations__list > details');
    document.querySelectorAll('.pdp__panel').forEach(panel => {
      const nodes = Array.from(panel.querySelectorAll(':scope > .pdp-smart, :scope > .pdp__description, :scope > .pdp__more-link'));
      const detail = disclosure(panel, null, nodes, text('mcOverview'));
      if (detail) detail.classList.add('pdp__overview');
      const order = ['.pdp__sub', '.pdp__title', '.pdp__reviews', '.pdp__section-label', '.pdp__price', '.pdp__mobile-intro', 'form', '.pdp__enquiry', '.pdp__email-enquiry', '.pdp__delivery', '.pdp__leadnote', '.pdp__pills', '.pdp__details', '.pdp__overview', '.brochure-link', '.finance-callout'];
      const children = Array.from(panel.children);
      children.forEach(node => {
        const marker = document.createTextNode('');
        node.before(marker);
        reordered.push([node, marker]);
      });
      const rank = node => { const i = order.findIndex(selector => node.matches(selector)); return i < 0 ? order.length : i; };
      children.sort((a, b) => rank(a) - rank(b)).forEach(node => panel.append(node));
    });
    sectionDetails('.smart > .page-width, .stages > .page-width');
    card('.icon-grid > .icon-card');
    card('.outcome-grid > .outcome-card', ':scope > p:not(.eyebrow)');
    document.querySelectorAll('.model-card__body').forEach(parent => {
      const nodes = Array.from(parent.querySelectorAll(':scope > p:not(.eyebrow):not(.finance-tag)'));
      if (nodes.length) disclosure(parent, null, nodes, text('mcOverview'));
    });
    card('.hw-fmt__body', ':scope > p:not(.hw-fmt__kicker)');
    card('.bz-why__card');
    card('.bz-steps__list > li');
    document.querySelectorAll('.own__card').forEach(parent => {
      const plain = parent.querySelector('.own__plain');
      const scope = plain || parent;
      const heading = scope.querySelector(':scope > h3');
      const nodes = Array.from(scope.children).filter(n => n !== heading);
      if (heading && nodes.length) disclosure(scope, heading, nodes);
    });
    document.querySelectorAll('.tx__steps > li > div, .step-list > li > div').forEach(parent => {
      const heading = parent.querySelector(':scope > strong');
      const nodes = Array.from(parent.children).filter(n => n !== heading);
      if (heading && nodes.length) disclosure(parent, heading, nodes);
    });
    document.querySelectorAll('.footer__links > .footer__col').forEach((list, index) => {
      disclosure(list.parentElement, null, [list], text(index ? 'mcHelp' : 'mcShop'));
    });
    const cities = document.querySelector('.footer__cities');
    if (cities) disclosure(cities.parentElement, null, [cities], text('mcDelivery'));
    document.querySelectorAll('.article-content, .content-page > .page-width > .rte, .lp-story__body, .shopify-policy__body > .rte').forEach(readingNav);
    if (!/\/(policies|pages\/(delivery-returns|warranty|finance))(\/|$)/.test(location.pathname || '')) {
      document.querySelectorAll('.article-content, .content-page > .page-width > .rte, .seo-content__body').forEach(readingSections);
    }
    revealHash();
    restoreFocus(active);
  }

  function unmount() {
    if (!mounted) return;
    let active = activeControl();
    const nav = active && active.closest('.mc-page-nav');
    if (nav) {
      const link = active.closest('a[href^="#"]') || nav.querySelector('a[href^="#"]');
      active = link ? document.getElementById(decodeURIComponent(link.getAttribute('href').slice(1))) : null;
    } else if (active && active.tagName === 'SUMMARY' && active.parentElement.classList.contains('mc-disclosure')) {
      active = active.querySelector('h2,h3,strong') || active.parentElement.querySelector('.mc-disclosure__body a[href],.mc-disclosure__body button,.mc-disclosure__body input,.mc-disclosure__body select');
    }
    reordered.forEach(([node, marker]) => marker.replaceWith(node));
    reordered.length = 0;
    wrappers.reverse().forEach(({detail, moved}) => {
      moved.forEach(([node, marker]) => marker.replaceWith(node));
      detail.remove();
    });
    wrappers.length = 0;
    initialDetails.forEach((open, detail) => { detail.open = open; });
    initialDetails.clear();
    navs.forEach(entry => {
      if (entry.nav) entry.nav.remove();
      else if (entry.oldId !== null) entry.heading.id = entry.oldId;
    });
    navs.length = 0;
    document.documentElement.classList.remove('mc-mobile-ready');
    mounted = false;
    restoreFocus(active);
  }

  screen.addEventListener('change', () => screen.matches ? mount() : unmount());
  document.addEventListener('shopify:section:load', () => { unmount(); mount(); });
  window.addEventListener('hashchange', revealHash);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href^="#"]');
    if (!link || !screen.matches) return;
    queueMicrotask(revealHash);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();

